// extracted by mini-css-extract-plugin
export var characterCount = "TextInput-module--characterCount--58bd8";
export var editableFieldWrapper = "TextInput-module--editableFieldWrapper--839ae";
export var errorMessage = "TextInput-module--errorMessage--d1de8";
export var textInput = "TextInput-module--textInput--dc7e5";
export var textInputWrapper = "TextInput-module--textInputWrapper--12f97";
export var textInputWrapperLargeTextArea = "TextInput-module--textInputWrapperLargeTextArea--6f6a2 TextInput-module--textInputWrapper--12f97";